// extracted by mini-css-extract-plugin
module.exports = {"container":"Content_container__3EyfZ","tabItem":"Content_tabItem__1tI7A","row":"Content_row__2f0ne","image":"Content_image__2pFuc"};